import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { computed } from "@vue/reactivity";
import { onMounted, PropType, ref } from "vue";


const __default__ = {
  name: "SegmentedCotrol",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  segments: {
    type: Object as PropType<Array<string>>,
    required: true,
  },
  initialIndex: {
    type: Number,
    default: 0,
  },
  shouldShowOpacity: {
    type: Boolean,
    default: true,
  },
},
  emits: ["onChangedSegmentIndex"],
  setup(__props, { expose: __expose, emit: __emit }) {

_useCssVars(_ctx => ({
  "51f13bd6-segmentWidth": (_unref(segmentWidth))
}))

const props = __props;

const emit = __emit;

const selectedIndex = ref(props.initialIndex);

const onChangedSegmentIndex = (index: number) => {
  selectedIndex.value = index;
  emit("onChangedSegmentIndex", index);
};

const changeSegmentIndex = (index: number) => {
  // selectedIndex.value = index;
  onChangedSegmentIndex(index);
};

const segmentWidth = computed(() => `calc(100%  / ${props.segments.length})`);

const getSegmentStyle = (index: number) => {
  if (index !== selectedIndex.value) return;
  return {
    transition: "all 0.3s ease-in-out",
  };
};

const getUnderlineStyle = () => {
  return {
    left:
      selectedIndex.value === 0
        ? "0px"
        : `calc(100% / ${props.segments.length} * ${selectedIndex.value})`,
  };
};

onMounted(() => {
  onChangedSegmentIndex(selectedIndex.value);
});

__expose({ changeSegmentIndex });

const __returned__ = { props, emit, selectedIndex, onChangedSegmentIndex, changeSegmentIndex, segmentWidth, getSegmentStyle, getUnderlineStyle }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})